<template>
  <div>
    <Modal :value="open" :close="false" title="Abertura de caixa">
      <b-row>
        <b-col class="busca">
          <Label bold>Caixa</Label>
          <vSelect label="identification" v-model="caixa" class="busca-cliente" ref="buscaCaixa" :options="caixas"
            @input="changeCaixa">
            <template slot="no-options"> Selecione um caixa </template>
            <template slot="option" slot-scope="option">
              {{ 'Caixa: ' + option.identification }}
            </template>
            <template slot="selected-option" slot-scope="option">
              {{ 'Caixa: ' + option.identification }}
            </template>
          </vSelect>
        </b-col>
        <b-col class="busca" v-if="!isGerencial()">
          <Label bold>Documento</Label>
          <vSelect label="documentConfiguration" v-model="documentConfiguration" class="search-document-configurations" ref="searchDocumentConfigurations" :options="documentConfigurations"
            @input="changeDocumentConfiguration">
            <template slot="no-options"> Selecione um documento </template>
            <template slot="option" slot-scope="option">
              {{ option.documento === '59' ? 'SAT/MFE' : 'NFCe' }} -
              {{ option.documento }}
              {{ option.serie ? ('Serie ' + option.serie) : '' }}
            </template>
            <template slot="selected-option" slot-scope="option">
              {{ option.documento === '59' ? 'SAT/MFE' : 'NFCe' }} -
              {{ option.documento }}
              {{ option.serie ? ('Serie ' + option.serie) : '' }}
            </template>
          </vSelect>
        </b-col>
        <b-col>
          <Money ref="valorAbertura" id="valorAbertura" :options="quantity" label="Valor para abertura" labelBold
            inputClass="form-control input" v-model="value" />
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6" lg="6" sm="12">
          <Label for="imprimirComprovante" bold>Imprimir comprovante</Label>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6" lg="6" sm="12">
          <checkbox-switch :ckecked="true" v-model="checkGeneratePrint" id="imprimirComprovante"
            style="margin: 0px !important" />
        </b-col>
      </b-row>
      <div class="confirm-buttons">
        <Button type="error" @click="closePDV()">Sair do PDV</Button>
        <Button type="success" @click="save()">Gravar</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import api from '@/configurations/service';
import { mapState, mapActions } from 'vuex';
import vSelect from 'vue-select';
import { Modal } from '@/components';
import { Button, Label, CheckboxSwitch } from '@/components/Form';
import Money from '../Form/InputMoney';
import { MODELO } from '../../enums/Documento';

export default {
  name: 'ModalOpenCheckout',
  components: {
    Modal,
    Button,
    Money,
    vSelect,
    Label,
    CheckboxSwitch,
  },
  data() {
    return {
      value: 0,
      caixas: [],
      caixa: null,
      documentConfigurations: [],
      documentConfiguration: null,
      quantity: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        precision: 2,
        masked: true,
      },
      checkGeneratePrint: false,
    };
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    close: {
      type: Function,
      required: true,
    },
    openCheckout: {
      type: Function,
      required: true,
    },
  },
  methods: {
    async getCaixas() {
      try {
        const { data } = await this.$http.post('fiscal.get-checkout', {
          status: true,
          byCurrentUser: true,
        });
        this.caixas = data;
      } catch (e) {
        this.$alert.error(e?.response?.data?.error_message);
      }
    },
    async getDocumentConfigurations() {
      try {
        const modelDocuments = [MODELO.NFCE, MODELO.SAT];

        const { data } = await api(2).post('fiscal.get-configurations-by-client', {
          withoutDevices: true,
          modelDocuments,
        });

        const documentConfigurations = data.filter(
          (config) =>
            config.ativo && modelDocuments.includes(config.documento),
        );

        this.documentConfigurations = documentConfigurations;
      } catch (e) {
        this.$alert.error(e?.response?.data?.error_message);
      }
    },
    setCaixaByPersonInCharge() {
      const caixa = this.caixas.find((e) => e.user.id === this.user.id);
      this.caixa = caixa;
    },
    closePDV() {
      window.location.href = '/';
    },
    changeCaixa(selectedCaixa) {
      this.caixa = selectedCaixa;
      this.$nextTick(() => {
      const elementToFocus = this.isGerencial()
        ? this.$refs.valorAbertura.$el.querySelector('input')
        : this.$refs.searchDocumentConfigurations.$el.querySelector('input');

      if (elementToFocus) {
        elementToFocus.focus();
      }
      });
    },
    changeDocumentConfiguration(selectedConfiguration) {
      this.documentConfiguration = selectedConfiguration;
      this.$nextTick(() => {
        this.$refs.valorAbertura.$el.querySelector('input').focus();
      });
    },
    isGerencial() {
      const { gerencial } = this.$route.params;
      return !!gerencial;
    },
    save() {
      if (this.caixa == null) {
        this.$alert.warning('Selecione um caixa!');
        return false;
      }

      if (!this.documentConfiguration && !this.isGerencial()) {
        this.$alert.warning('Selecione um documento!');
        return false;
      }

      this.setGeneratePrint(
        this.checkGeneratePrint ? this.checkGeneratePrint : 0,
      );

      this.openCheckout({
        value: this.value,
        caixa: this.caixa,
        documentConfiguration: this.documentConfiguration,
        generatePrint: this.checkGeneratePrint ? this.checkGeneratePrint : 0,
      });

      this.value = 0;
      this.setCaixaByPersonInCharge();

      return true;
    },
    ...mapActions('pdv', ['setGeneratePrint']),
  },
  async mounted() {
    await this.getCaixas();
    await this.getDocumentConfigurations();
    this.setCaixaByPersonInCharge();
  },
  computed: {
    ...mapState('user', ['user']),
    ...mapState('pdv', ['generatePrint']),
  },
  watch: {
    generatePrint(newValue) {
      this.checkGeneratePrint = newValue;
    },
  },
};
</script>

<style>
.text-center label {
  margin-bottom: 10px !important;
}
</style>
